import { Type } from 'class-transformer';

export class AccItemDetailResultDto {
    accItemId: number;
    category: string;
    daysRemaining: number;

    @Type(() => Date)
    dueDate: Date;

    @Type(() => Date)
    allowanceStartDate: Date;

    @Type(() => Date)
    allowanceEndDate: Date;

    @Type(() => Date)
    committeeSubmittedDate: Date;

    status: string;
    docCount: number;
    hasNotes: boolean;
    allowanceCategory: string;
    allowanceSubCategory: string;
    depositStatus: string;
    depositType: string;
    finalized: boolean;

    description: string;
    depositRef: string;
    depositAmount: number;
    responseToOwner: string;
}
